import { render } from "./StudentThought.vue?vue&type=template&id=0cc7569d"
import script from "./StudentThought.vue?vue&type=script&lang=js"
export * from "./StudentThought.vue?vue&type=script&lang=js"

import "./StudentThought.vue?vue&type=style&index=0&id=0cc7569d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__